import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { AuthCallback } from './pages/AuthCallback';
import { Dashboard } from './pages/Dashboard';
import { PaymentSuccess } from './pages/PaymentSuccess';
import { Admin } from './pages/Admin';
import { About } from './pages/About';
import { HowTo } from './pages/HowTo';
import { Landing } from './pages/Landing';
import { CreativePartner } from './pages/CreativePartner';
import { CinematicStudio } from './pages/CinematicStudio';

function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id from Google OAuth - handle synchronously
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/welcome" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/auth-callback" element={<AuthCallback />} />
      <Route path="/about" element={<About />} />
      <Route path="/how-to" element={<HowTo />} />
      <Route path="/creative-partner" element={<CreativePartner />} />
      <Route
        path="/cinematic-studio"
        element={
          <ProtectedRoute>
            <CinematicStudio />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cinematic-studio/:projectId"
        element={
          <ProtectedRoute>
            <CinematicStudio />
          </ProtectedRoute>
        }
      />
      <Route
        path="/payment-success"
        element={
          <ProtectedRoute>
            <PaymentSuccess />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <Admin />
          </ProtectedRoute>
        }
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
